var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 35,
    viewBox: "0 0 42 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7202 4.60947C40.1693 5.29646 38.5168 5.75182 36.794 5.97292C38.5664 4.90427 39.9191 3.22496 40.5551 1.20084C38.9026 2.19579 37.0781 2.89857 35.1337 3.29076C33.5646 1.60356 31.3283 0.558594 28.8887 0.558594C24.1554 0.558594 20.3447 4.43838 20.3447 9.19467C20.3447 9.87903 20.4021 10.5371 20.5428 11.1635C13.4351 10.8134 7.14571 7.37322 2.92067 2.13262C2.18304 3.425 1.75037 4.90427 1.75037 6.49672C1.75037 9.48684 3.27514 12.1374 5.54796 13.672C4.17437 13.6456 2.82683 13.2429 1.68521 12.6086C1.68521 12.6349 1.68521 12.6691 1.68521 12.7033C1.68521 16.899 4.64874 20.3839 8.53494 21.1867C7.83902 21.3789 7.08055 21.471 6.2934 21.471C5.74605 21.471 5.19348 21.4394 4.6748 21.3236C5.78254 24.7428 8.92591 27.2565 12.6635 27.3381C9.75476 29.6359 6.06143 31.0204 2.06315 31.0204C1.36201 31.0204 0.689552 30.9888 0.0170898 30.902C3.80425 33.3683 8.29254 34.7765 13.1327 34.7765C28.8652 34.7765 37.4665 21.6158 37.4665 10.208C37.4665 9.82638 37.4534 9.45788 37.4352 9.09202C39.132 7.87596 40.5577 6.35721 41.7202 4.60947Z",
    fill: "#0476ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1f097c4dafe43d412359f27da2709bb3.svg";
export { ForwardRef as ReactComponent };